import * as sagas from './sagas'
import * as selectors from './selectors'
import reducer from './reducer'

export default {
  reducer,
  sagas,
  selectors,
}
